import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { sleep } from '~/utils'

const fakeResponse = async <T>(
  url: string,
  _options: AxiosRequestConfig = {},
): Promise<T> => {
  if (url.includes('/FIXME/getAppVersion')) {
    return {
      data: {
        requiredBuildNumber: 1,
      },
    } as T
  }
  return null as T
}

const fakeFetch = async <T>(
  url: string,
  options: AxiosRequestConfig = {},
): Promise<{ data: T }> => {
  await sleep(1000)
  return { data: await fakeResponse(url, options) }
}

const get = fakeFetch
const post = fakeFetch

export default {
  get,
  post,
} as AxiosInstance
